import { makeStyles } from "@fluentui/react-components";
import { dolphinTokens } from "../../utils/Theme";
export const TRUST_STRIP_BG = "rgb(230, 243, 246)";

interface ITrustStripProps {
    items?: string[];
}

const useStyles = makeStyles({
    strip: {
        backgroundColor: TRUST_STRIP_BG,
        borderBottom: `1px solid ${dolphinTokens.colorLightBlue20}`,
        padding: "1.5rem 2rem",
        flexShrink: 0,
        "@media (max-width: 980px)": {
            padding: "0.75rem 1rem",
        },
    },
    list: {
        display: "flex",
        flexWrap: "wrap",
        justifyContent: "center",
        alignItems: "center",
        columnGap: "clamp(1.5rem, 4vw, 3rem)",
        rowGap: "0.75rem",
        maxWidth: "1400px",
        margin: "0 auto",
        padding: 0,
        listStyleType: "none",
        "@media (max-width: 980px)": {
            columnGap: "1rem",
            rowGap: "0.5rem",
        },
    },
    item: {
        display: "flex",
        alignItems: "center",
        gap: "0.5rem",
        fontSize: "0.9rem",
        fontWeight: 500,
        color: dolphinTokens.colorDarkBlue80,
        "@media (max-width: 980px)": {
            fontSize: "0.8rem",
        },
    },
    dot: {
        width: "8px",
        height: "8px",
        borderRadius: "50%",
        flexShrink: 0,
    },
    dotBlue: { backgroundColor: dolphinTokens.colorLightBlue },
    dotMint: { backgroundColor: dolphinTokens.colorMintGreen },
    dotPeach: { backgroundColor: dolphinTokens.colorPeachOrange },
    dotLavender: { backgroundColor: dolphinTokens.colorSkyLavender },
});

const defaultItems = [
    "Microsoft Partner",
    "15+ years experience",
    "Trusted by growing businesses",
    "Based in Guildford, Surrey",
];

export default function TrustStrip({ items = defaultItems }: ITrustStripProps) {
    const styles = useStyles();
    const dotColours = [styles.dotBlue, styles.dotMint, styles.dotPeach, styles.dotLavender];

    return (
        <div className={styles.strip}>
            <ul className={styles.list}>
                {items.map((item, i) => (
                    <li key={item} className={styles.item}>
                        <span
                            className={`${styles.dot} ${dotColours[i % dotColours.length]}`}
                            aria-hidden="true"
                        />
                        {item}
                    </li>
                ))}
            </ul>
        </div>
    );
}